import DealCard from '../components/DealCard';

export default function ForYouPage({ recommendations, loading, shoppingList, favourites, onAddToList, onToggleFavourite, user, onSignIn }) {
  const listSet = new Set((shoppingList || []).map(i => i.name + i.store));
  const favSet  = new Set((favourites   || []).map(f => f.name + f.store));

  if (!user) {
    return (
      <div className="fav-empty">
        <p className="fav-empty-icon">✦</p>
        <p className="fav-empty-title">Personalised picks</p>
        <p className="fav-empty-hint">
          Sign in to see deals recommended based on your shopping history and favourites.
        </p>
        <button className="btn-signin" style={{ marginTop: 16 }} onClick={onSignIn}>Sign in</button>
      </div>
    );
  }

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '60px 16px', color: 'var(--muted)' }}>Loading your picks…</div>;
  }

  if (!recommendations?.length) {
    return (
      <div className="fav-empty">
        <p className="fav-empty-icon">✦</p>
        <p className="fav-empty-title">No picks yet</p>
        <p className="fav-empty-hint">
          Add items to your shopping list or save favourites — we'll surface deals tailored to what you buy.
        </p>
      </div>
    );
  }

  return (
    <div className="foryou-page">
      <div className="foryou-header">
        <h2 className="foryou-title">Picks for you</h2>
        <p className="foryou-subtitle">{recommendations.length} deals based on your shopping history &amp; favourites</p>
      </div>
      <div className="deal-grid">
        {recommendations.map((deal, i) => (
          <div key={i} className="rec-card-wrap">
            <div className="rec-reason">{deal.reason}</div>
            <DealCard
              deal={deal}
              onAddToList={onAddToList}
              inList={listSet.has(deal.name + deal.store)}
              isFavourited={favSet.has(deal.name + deal.store)}
              onToggleFavourite={onToggleFavourite}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
